import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";

import perfumesSlice, { PerfumesState } from "./redux-toolkit/perfumes/perfumes-slice";
import perfumeSlice, { PerfumeState } from "./redux-toolkit/perfume/perfume-slice";
import userSlice, { UserState } from "./redux-toolkit/user/user-slice";
import ordersSlice, { OrdersState } from "./redux-toolkit/orders/orders-slice";
import orderSlice, { OrderState } from "./redux-toolkit/order/order-slice";
import cartSlice, { CartState } from "./redux-toolkit/cart/cart-slice";
import authSlice, { AuthState } from "./redux-toolkit/auth/auth-slice";
import adminSlice, { AdminState } from "./redux-toolkit/admin/admin-slice";
import homeSlice, { HomeState } from "./redux-toolkit/home/home-slice";

// ✅ Define RootState interface
export interface RootState {
admin: AdminState;
auth: AuthState;
cart: CartState;
order: OrderState;
orders: OrdersState;
perfume: PerfumeState;
perfumes: PerfumesState;
user: UserState;
home: HomeState;
}

// ✅ Combine all reducers here
export const storeReducer = {
admin: adminSlice,
auth: authSlice,
cart: cartSlice, // ✅ included here
order: orderSlice,
orders: ordersSlice,
perfume: perfumeSlice,
perfumes: perfumesSlice,
user: userSlice,
home: homeSlice,
};

// ✅ Configure the store properly
export const store = configureStore({
reducer: storeReducer,
});

// ✅ Typed hooks (for TS-safe usage)
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
